// extracted by mini-css-extract-plugin
export var closeButton = "_fk-2";
export var closeButtonIcon = "_fk-3";
export var lightboxContent = "_fk-1";
export var lightboxOverlay = "_fk-0";